/**
 * Phonics Review: Oo → Yy
 * 组合 PPT 有台词的 storySection，按字母顺序排列
 * 媒体文件直接引用原字母目录，不创建新媒体
 */

const MB_OO = '/media/phonics/oo';
const MB_QQ = '/media/phonics/qq';
const MB_RR = '/media/phonics/rr';
const MB_SS = '/media/phonics/ss';
const MB_VV = '/media/phonics/vv';
const MB_XX = '/media/phonics/xx';
const MB_YY = '/media/phonics/yy';

export const letterDataOoYY = {
  mediaBase: MB_OO, // 默认回退路径（instruction audio）

  storySections: [

    // ===== Oo — Story 2: Ox / Otter best friend（P4，仅英文配音） =====
    {
      label: 'Oo - Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      instructionAudio: `${MB_OO}/audio_instruction_repeat.mp3`,
      videos: [{ src: `${MB_OO}/video_story_oo2.mp4?v1` }],
      lines: [
        { en: "Ox, who is your best friend?", audioEn: `${MB_OO}/story2_en_1.mp3?v1` },
        { en: "Otter is my best friend.", audioEn: `${MB_OO}/story2_en_2.mp3?v1` },
      ],
    },

    // ===== Qq — Story 1: Who is this? / queen =====
    {
      label: 'Qq - Learn the Story (1)',
      layout: 'video-left-vocab-right',
      instructionAudio: `${MB_QQ}/audio_instruction_repeat.mp3`,
      videos: [{ src: `${MB_QQ}/video_story_queen.mp4?v1`, poster: `${MB_QQ}/image13.png?v1` }],
      splitAt: 3,
      lines: [
        { en: 'time', cn: '时间', audioEn: `${MB_QQ}/w_en_time.mp3?v1`, audioCn: `${MB_QQ}/w_cn_time.mp3?v1` },
        { en: 'quiz time', cn: '竞猜时间', audioEn: `${MB_QQ}/w_en_quiz_time.mp3?v1`, audioCn: `${MB_QQ}/w_cn_quiz_time.mp3?v1` },
        { en: 'quick', cn: '快', audioEn: `${MB_QQ}/w_en_quick.mp3?v1`, audioCn: `${MB_QQ}/w_cn_quick.mp3?v1` },
        { en: "Who is this?", cn: '这是谁？', audioEn: `${MB_QQ}/story1_en_1.mp3?v1`, audioCn: `${MB_QQ}/story1_cn_1.mp3?v1` },
        { en: "It's a queen.", cn: '这是一个女王。', audioEn: `${MB_QQ}/story1_en_2.mp3?v1`, audioCn: `${MB_QQ}/story1_cn_2.mp3?v1` },
        { en: 'Yes! Good job!', cn: '是的！做得好！', audioEn: `${MB_QQ}/story1_en_3.mp3?v1`, audioCn: `${MB_QQ}/story1_cn_3.mp3?v1` },
      ],
    },

    // ===== Qq — Story 2: What is this? / quilt =====
    {
      label: 'Qq - Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      instructionAudio: `${MB_QQ}/audio_instruction_repeat.mp3`,
      videos: [{ src: `${MB_QQ}/video_story_quilt.mp4?v1`, poster: `${MB_QQ}/image14.png?v1` }],
      lines: [
        { en: 'What is this?', audioEn: `${MB_QQ}/story2_en_1.mp3?v1` },
        { en: "It's a quilt.", audioEn: `${MB_QQ}/story2_en_2.mp3?v1` },
        { en: 'Yes! Good job!', audioEn: `${MB_QQ}/story2_en_3.mp3?v1` },
      ],
    },

    // ===== Rr — Story 2: Rat! Rat! / Red =====
    {
      label: 'Rr - Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      instructionAudio: `${MB_RR}/audio_instruction_repeat.mp3`,
      videos: [
        { src: `${MB_RR}/video_story_color.mp4`, poster: `${MB_RR}/image14.png` },
      ],
      lines: [
        { en: 'Rat! Rat! What color do you like?', cn: '鼠鼠！鼠鼠！你喜欢什么颜色？', audioEn: `${MB_RR}/story2_en_1.mp3`, audioCn: `${MB_RR}/story2_cn_1.mp3` },
        { en: 'Red! Red! I like red.', cn: '红！红！我喜欢红色。', audioEn: `${MB_RR}/story2_en_2.mp3`, audioCn: `${MB_RR}/story2_cn_2.mp3` },
      ],
    },

    // ===== Ss — Story 1: Sam went to sea =====
    {
      label: 'Ss - Learn the Story (1)',
      layout: 'video-left-vocab-right',
      instructionAudio: `${MB_SS}/audio_instruction_repeat.mp3`,
      videos: [
        { src: `${MB_SS}/video_story_sea.mp4`, poster: `${MB_SS}/image13.png` },
      ],
      splitAt: 3,
      lines: [
        { en: 'went', cn: '去', audioEn: `${MB_SS}/w_en_went.mp3`, audioCn: `${MB_SS}/w_cn_went.mp3` },
        { en: 'there is', cn: '有', audioEn: `${MB_SS}/w_en_there_is.mp3`, audioCn: `${MB_SS}/w_cn_there_is.mp3` },
        { en: 'splash', cn: '溅水的声音', audioEn: `${MB_SS}/w_en_splash.mp3`, audioCn: `${MB_SS}/w_cn_splash.mp3` },
        { en: 'Sam went to sea.', cn: 'Sam出海。', audioEn: `${MB_SS}/story1_en_1.mp3`, audioCn: `${MB_SS}/story1_cn_1.mp3` },
        { en: 'There is the sun.', cn: '有太阳。', audioEn: `${MB_SS}/story1_en_2.mp3`, audioCn: `${MB_SS}/story1_cn_2.mp3` },
        { en: 'Oh, no! Where is the sun?', cn: '太阳哪儿去了？', audioEn: `${MB_SS}/story1_en_3.mp3`, audioCn: `${MB_SS}/story1_cn_3.mp3` },
      ],
    },

    // ===== Vv — Story 1: Let's go shopping / vase =====
    {
      label: 'Vv - Learn the Story (1)',
      layout: 'video-left-vocab-right',
      instructionAudio: `${MB_VV}/audio_instruction_repeat.mp3`,
      videos: [
        { src: `${MB_VV}/video_story_1.mp4`, poster: `${MB_VV}/image13.png` },
      ],
      splitAt: 5,
      lines: [
        { en: "Let's", cn: '让我们去购物吧', audioEn: `${MB_VV}/w_en_let's.mp3`, audioCn: `${MB_VV}/w_cn_let's.mp3` },
        { en: 'mom', cn: '妈妈', audioEn: `${MB_VV}/w_en_mom.mp3`, audioCn: `${MB_VV}/w_cn_mom.mp3` },
        { en: 'get', cn: '买', audioEn: `${MB_VV}/w_en_get.mp3`, audioCn: `${MB_VV}/w_cn_get.mp3` },
        { en: 'got', cn: '买了', audioEn: `${MB_VV}/w_en_got.mp3`, audioCn: `${MB_VV}/w_cn_got.mp3` },
        { en: 'love', cn: '很喜欢', audioEn: `${MB_VV}/w_en_love.mp3`, audioCn: `${MB_VV}/w_cn_love.mp3` },
        { en: "Let's go shopping.", cn: '让我们去购物吧。', audioEn: `${MB_VV}/story1_en_1.mp3`, audioCn: `${MB_VV}/story1_cn_1.mp3` },
        { en: "What did you get, Mom?", cn: '妈妈，你买了什么？', audioEn: `${MB_VV}/story1_en_2.mp3`, audioCn: `${MB_VV}/story1_cn_2.mp3` },
        { en: "I got a vase.", cn: '我买了一个花瓶。', audioEn: `${MB_VV}/story1_en_3.mp3`, audioCn: `${MB_VV}/story1_cn_3.mp3` },
        { en: "Oh, I love the vase.", cn: '我很喜欢这个花瓶。', audioEn: `${MB_VV}/story1_en_4.mp3`, audioCn: `${MB_VV}/story1_cn_4.mp3` },
      ],
    },

    // ===== Xx — Story 1: What's in the box? / fox =====
    {
      label: 'Xx - Learn the Story (1)',
      layout: 'video-left-vocab-right',
      instructionAudio: `${MB_XX}/audio_instruction_repeat.mp3`,
      splitAt: 2,
      videos: [{ src: `${MB_XX}/video_story_1.mp4`, poster: `${MB_XX}/image13.png` }],
      lines: [
        { en: "There's a...", cn: '有一个...', audioEn: `${MB_XX}/w_en_story1_theres_a.mp3`, audioCn: `${MB_XX}/w_cn_story1_theres_a.mp3` },
        { en: 'Cute', cn: '可爱的', audioEn: `${MB_XX}/w_en_story1_cute.mp3`, audioCn: `${MB_XX}/w_cn_story1_cute.mp3` },
        { en: "What's in the box?", cn: '盒子里有什么？', audioEn: `${MB_XX}/story1_en_1.mp3`, audioCn: `${MB_XX}/story1_cn_1.mp3` },
        { en: "There's a fox in the box!", cn: '盒子里有一只狐狸！', audioEn: `${MB_XX}/story1_en_2.mp3`, audioCn: `${MB_XX}/story1_cn_2.mp3` },
        { en: 'Cute fox.', cn: '可爱的狐狸。', audioEn: `${MB_XX}/story1_en_3.mp3`, audioCn: `${MB_XX}/story1_cn_3.mp3` },
      ],
    },

    // ===== Xx — Story 3: What's in the box? / six eggs =====
    {
      label: 'Xx - Learn the Story (3)',
      layout: 'video-left-vocab-right',
      instructionAudio: `${MB_XX}/audio_instruction_repeat.mp3`,
      splitAt: 2,
      videos: [{ src: `${MB_XX}/video_story_3.mp4`, poster: `${MB_XX}/image15.png` }],
      lines: [
        { en: 'There are 6...', cn: '有6个...', audioEn: `${MB_XX}/w_en_story3_there_are_6.mp3`, audioCn: `${MB_XX}/w_cn_story3_there_are_6.mp3` },
        { en: 'baby', cn: '小宝贝', audioEn: `${MB_XX}/w_en_story3_baby.mp3`, audioCn: `${MB_XX}/w_cn_story3_baby.mp3` },
        { en: "What's in the box?", cn: '盒子里有什么？', audioEn: `${MB_XX}/story3_en_1.mp3`, audioCn: `${MB_XX}/story3_cn_1.mp3` },
        { en: 'There are six eggs in the box!', cn: '盒子里有六个蛋！', audioEn: `${MB_XX}/story3_en_2.mp3`, audioCn: `${MB_XX}/story3_cn_2.mp3` },
        { en: 'Six baby dinosaurs!', cn: '六只小恐龙！', audioEn: `${MB_XX}/story3_en_3.mp3`, audioCn: `${MB_XX}/story3_cn_3.mp3` },
      ],
    },

    // ===== Yy — Story 1: Yawn! / yo-yos =====
    {
      label: 'Yy - Learn the Story (1)',
      layout: 'video-left-vocab-right',
      instructionAudio: `${MB_YY}/audio_instruction_repeat.mp3`,
      splitAt: 5,
      videos: [{ src: `${MB_YY}/video_story_1.mp4`, poster: `${MB_YY}/image13.png` }],
      lines: [
        { en: 'yawn', cn: '打哈欠', audioEn: `${MB_YY}/w_en_s1_yawn.mp3`, audioCn: `${MB_YY}/w_cn_s1_yawn.mp3` },
        { en: 'should', cn: '应该', audioEn: `${MB_YY}/w_en_s1_should.mp3`, audioCn: `${MB_YY}/w_cn_s1_should.mp3` },
        { en: 'play', cn: '玩', audioEn: `${MB_YY}/w_en_s1_play.mp3`, audioCn: `${MB_YY}/w_cn_s1_play.mp3` },
        { en: 'with', cn: '用...一起', audioEn: `${MB_YY}/w_en_s1_with.mp3`, audioCn: `${MB_YY}/w_cn_s1_with.mp3` },
        { en: 'play with', cn: '和...玩', audioEn: `${MB_YY}/w_en_s1_play_with.mp3`, audioCn: `${MB_YY}/w_cn_s1_play_with.mp3` },
        { en: "Yawn! Yawn! I'm bored.", cn: '打哈欠！打哈欠！我好无聊。', audioEn: `${MB_YY}/story1_en_1.mp3`, audioCn: `${MB_YY}/story1_cn_1.mp3` },
        { en: 'What should I do?', cn: '我该做什么呢？', audioEn: `${MB_YY}/story1_en_2.mp3`, audioCn: `${MB_YY}/story1_cn_2.mp3` },
        { en: 'I have some yo-yos.', cn: '我有一些悠悠球。', audioEn: `${MB_YY}/story1_en_3.mp3`, audioCn: `${MB_YY}/story1_cn_3.mp3` },
        { en: "Let's play with the yo-yos.", cn: '我们玩悠悠球吧。', audioEn: `${MB_YY}/story1_en_4.mp3`, audioCn: `${MB_YY}/story1_cn_4.mp3` },
      ],
    },

    // ===== Yy — Story 3: yogurt =====
    {
      label: 'Yy - Learn the Story (3)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `${MB_YY}/audio_instruction_repeat.mp3`,
      splitAt: 3,
      videos: [{ src: `${MB_YY}/video_story_3.mp4`, poster: `${MB_YY}/image15.png` }],
      lines: [
        { en: "Yawn! Yawn!", audioEn: `${MB_YY}/story3_en_1.mp3` },
        { en: "I'm bored.", audioEn: `${MB_YY}/story3_en_2.mp3` },
        { en: "What should I do?", audioEn: `${MB_YY}/story3_en_3.mp3` },
        { en: "I have some yogurt.", audioEn: `${MB_YY}/story3_en_4.mp3` },
        { en: "Let's eat some yogurt.", audioEn: `${MB_YY}/story3_en_5.mp3` },
        { en: "Yellow yogurt!", audioEn: `${MB_YY}/story3_en_6.mp3` },
        { en: "I love the yellow yogurt.", audioEn: `${MB_YY}/story3_en_7.mp3` },
      ],
    },

  ],
};

export default letterDataOoYY;
